import { Activity, Plus } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { usePlansTab } from '@/hooks/usePlansTab'
import { PlansTabList } from '@/components/Configuracao/PlansTabList'
import { PlansTabModal } from '@/components/Configuracao/PlansTabModal'
import type { PlanCatalogScope } from '@/utils/planCatalog'

interface PlansTabProps {
  catalogScope?: PlanCatalogScope
}

export function PlansTab({ catalogScope }: PlansTabProps) {
  const tab = usePlansTab(catalogScope ? { catalogScope } : undefined)
  const isRocketServices = catalogScope === 'rocket'

  return (
    <div className="glass-card space-y-6">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h3
            className="font-semibold text-[var(--font-color-h3)] flex items-center gap-2"
            style={{ fontSize: 'var(--font-size-h3)' }}
          >
            <Activity size={20} className="text-[var(--brand-primary)]" />
            {isRocketServices ? 'Serviços prestados — Rocket Search' : 'Matrix de Planos Oficiais'}
          </h3>
          <p className="text-[var(--text-muted)] mt-1" style={{ fontSize: 'var(--font-size-sm)' }}>
            {isRocketServices
              ? 'Catálogo Galaxy e demais serviços Rocket disponíveis nas propostas.'
              : 'Controle as entregas e as duas modalidades mensais de precificação.'}
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="secondary" size="sm" onClick={tab.fetchPlans} icon={<Activity size={14} />}>
            Refresh
          </Button>
          <Button variant="primary" size="sm" onClick={tab.openNewPlanModal} icon={<Plus size={14} />}>
            {isRocketServices ? 'Novo Serviço' : 'Criar Novo Plano'}
          </Button>
        </div>
      </div>

      <div className="space-y-8">
        <PlansTabList
          plans={tab.plans}
          loading={tab.loading}
          onEdit={tab.openEditModal}
          onDelete={tab.handleDeletePlan}
        />
      </div>

      <PlansTabModal
        editingPlan={tab.editingPlan}
        isCreating={tab.isCreating}
        modalTab={tab.modalTab}
        saving={tab.saving}
        deliverables={tab.modalDeliverables}
        totalHours={tab.modalTotalHours}
        calculatedValue={tab.modalCalculatedValue}
        onClose={tab.closeModal}
        onSave={tab.handleSavePlan}
        onTabChange={tab.setModalTab}
        onPlanChange={tab.setEditingPlan}
        onDeliverableChange={tab.handleDeliverableChange}
        onAddDeliverable={tab.addDeliverable}
        onRemoveDeliverable={tab.removeDeliverable}
      />
    </div>
  )
}
